import { supabase } from "../supabase/client";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL!;

/** Make sure not to include prefix slash */
export default async function backendFetch(
  endpoint: string,
  method: string,
  data?: any
) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  let accessToken: undefined | string = "";

  if (session) {
    accessToken = session.access_token;
  }

  const authHeader: { Authorization: string } | {} = accessToken
    ? {
        Authorization: `${accessToken}`,
      }
    : {};

  const url = `${BACKEND_URL}/${endpoint}`;

  const jsonHeaders: HeadersInit = authHeader;

  if (data) {
    jsonHeaders["Content-Type"] = "application/json";
  }

  //TODO: Authorization
  return fetch(url, {
    method,
    headers: {
      ...jsonHeaders,
    },
    body: data ? JSON.stringify(data) : undefined,
  });
}
